<template>
    <div>
        <headroom :z-index="1000">
            <header class="main-header">
                <div class="main-header__inner">
                    <router-link 
                        :to="{ name: 'home' }" 
                        class="main-header__logo">
                        <img src="/img/logo.png/300x0_ratio/logo.png" alt="Logo">
                    </router-link>
                    <div class="main-header__nav">
                        <nav class="main-header__navigation">
                            <menu-component 
                                :pages="$store.state.navigation.items" 
                                list-class="main-header__list" 
                                submenu-class="main-header__sub" 
                                item-class="main-header__item" 
                                link-class="main-header__link">
                            </menu-component>
                        </nav>

                        <nav class="main-header__navigation">
                            <member-frontnav-component></member-frontnav-component>
                        </nav>
                    
                        <div v-if="$store.state.languages.length > 1" class="main-header__lang">
                            <language-switch-component></language-switch-component>
                        </div>
                    </div>
                </div>
            </header>
        </headroom>

        <div class="mobile-nav__action">
            <div class="d-flex align-items-center pl-1">
                <a class="mobile-nav__link mr-2" href="tel:#" data-ga-track data-ga-category="Phone" data-ga-action="call" data-ga-label="#">
                    Phone
                </a>
                <a class="mobile-nav__link mr-2" href="mailto:#" data-ga-track data-ga-category="E-Mail" data-ga-action="click" data-ga-label="#">
                    Mail
                </a>
                <a class="mobile-nav__link mr-2" href="https://www.google.com/maps?q=#" target="_blank" data-ga-track data-ga-category="Map" data-ga-action="click">
                    Map
                </a>
            </div>
            <div class="mobile-nav__hamburger">
                <button 
                    class="hamburger hamburger--spin" 
                    :class="{ 'is-active': $store.state.navigation.isOpen }" 
                    @click="$store.dispatch('navigation/toggle')"
                    type="button">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>
            </div>
        </div>
        <transition name="mobile-nav">
            <div v-show="$store.state.navigation.isOpen" class="mobile-nav">
                <nav class="main-header__navigation">
                    <menu-component 
                        :pages="$store.state.navigation.items" 
                        list-class="main-header__list" 
                        submenu-class="main-header__sub" 
                        item-class="main-header__item" 
                        link-class="main-header__link">
                    </menu-component>
                </nav>
            </div>
        </transition>
    </div>
</template>
<script>
import Menu from '#app#/components/package/RF/CMS/Menu.vue';
import LanguageSwitch from '#app#/components/common/LanguageSwitch.vue';
import MemberFrontNav from '#app#/components/package/RF/Member/FrontNav.vue';
import { headroom } from 'vue-headroom';

export default {
    components: {
        headroom,
        'menu-component': Menu,
        'language-switch-component': LanguageSwitch,
        'member-frontnav-component': MemberFrontNav
    },

    watch: {
        $route() {
            this.$store.dispatch('navigation/close');
        }
    },
}
</script>



// WEBPACK FOOTER //
// ../default-js/js/components/common/Navigation.vue